import * as React from "react";
import styled from "styled-components";
import { IconKeyboardArrowDown, IconProperty } from "@origin-digital/ods-icons";
import { Select, SelectElementProps } from "../SelectElement";

const StyledIconKeyboardArrowDown = styled((props) => (
  <IconKeyboardArrowDown {...props} />
))`
  && {
    pointer-events: none;
    color: ${(p) => p.theme.colors.error};
  }
`;

const StyledIconProperty = styled((props) => <IconProperty {...props} />)`
  && {
    font-size: 20px;
    color: ${(p) => p.theme.colors.grey300};
  }
`;

const FullSelectContainer = styled.div`
  display: flex;
  flex: 1 1;
  align-items: center;
  flex-direction: row;

  > :first-child {
    margin-right: 8px;
  }
`;

const SelectIconsContainer = styled.div`
  display: flex;
  align-items: center;
  pointer-events: none; /* let the click pass trough */
`;

export const FullSelect = (props: SelectElementProps) => {
  return (
    <FullSelectContainer>
      <StyledIconProperty />
      <Select {...props} />
      <StyledIconKeyboardArrowDown color="critical" />
    </FullSelectContainer>
  );
};

export const CompactSelect = (props: SelectElementProps) => {
  return (
    <>
      <Select {...props} hidden />
      <SelectIconsContainer>
        <StyledIconProperty />
        <IconKeyboardArrowDown color="critical" />
      </SelectIconsContainer>
    </>
  );
};
